package com.example.readingnotes.domain.model

enum class UserRole {
    ADMIN,
    PUBLIC,
}
